<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to Settings" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn> 
                    <v-spacer></v-spacer>
                    <help-link appId="settings" pageId="workshifts" color="white"></help-link>
                    <v-btn dark color="primary" title="Add Work Shift" @click="addSchedule">
                        <v-icon dark>add</v-icon>&nbsp;Add&nbsp;
                    </v-btn>
                </v-toolbar>
            </v-card>
            <v-alert v-if="error" :value="true" color="error" icon="error" outline style="margin-top:5px;">
                Error encountered. Please contact support. Error details: {{errorMessage}}
            </v-alert>  
            <v-card class="elavation-1" style="margin-top:5px;"> 
                <v-toolbar flat height="45px">
                    <div class="wp-30 mb-10">
                        <v-text-field v-model="search" append-icon="search" label="Search name, clock-start, clock-end" single-line hide-details></v-text-field>
                    </div>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-data-table
                    :headers="headers"
                    :items="schedules_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                >
                    <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                    <template v-slot:items="props">
                        <tr @click="showAddEdit(props.item)" title="Click to Edit" :style="`background-color:${props.item.color?props.item.color:'transparent'};cursor:pointer;`">
                            <td>{{ props.item.name }}</td>
                            <td>{{ props.item.clockStart | moment("h:mm a") }}</td>
                            <td>{{ props.item.clockEnd | moment("h:mm a")}}</td>
                            <td>
                                <div v-if="props.item.strict" class="text-xs-left">Strict</div>
                                <div v-if="!props.item.strict" class="text-xs-left">Flexible</div>
                            </td>
                            <td>
                                <span v-if="props.item.validateUndertime">Yes</span>
                                <span v-else>No</span>
                            </td>
                            <td>
                                <div v-if="props.item.strict" class="text-xs-left">{{props.item.gracePeriod}} minutes</div>
                                <div v-if="!props.item.strict" class="text-xs-left">N/A</div>
                            </td>
                            <td>{{ props.item.totalAssigned }}</td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>

            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="pageQueryId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>   

        <v-dialog v-model="dialogAdd" persistent width="600">
            <add-edit-schedule ref="addEditSchedule" :dialogAdd.sync="dialogAdd" @send="getSchedules"></add-edit-schedule> <!--@send, alternate to v-on:send-->
        </v-dialog>
       
        <!-- status messaging component -->
        <status-messaging :page_query_id="pageQueryId" @refresh="updateHandler"></status-messaging>
    </v-layout>  
</template>
<script>

import workShiftsApi from '@/api/workshift'
import commonfn from '@/common/functions'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {    
    name: 'CompanyWorkshifts',
    metaInfo: {
        title: 'Company Workshifts',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Company Workshifts' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'add-edit-schedule': () => import('@/components/WorkShifts/AddEditWorkShifts'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory')
    },
    data () {      
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            mode: null,
            schedules: [],      
            loading: false,
            search: null,
            dialogAdd: false,
            error: false,
            errorMessage: '', 
            snackbarText: '',
            headers: [
                {text:'Name', align:'left', value:'name', width: '30%', sortable:true},
                {text:'Clock-Start', align:'left', value:'clockStartHr',width: '10%', sortable:true},
                {text:'Clock-End', align:'left', value: 'clockEndHr', width: '10%', sortable:true},
                {text:'Type', align:'left', value: 'strict', width:'10%', sortable:true},
                {text:'Validate Undertime', align:'left', value: 'validateUndertime', width:'10%', sortable:true},
                {text:'Grace Period', align: 'left', value:'gracePeriod', width: '10%', sortable:false},
                {text:'Total Assigned', align: 'left', value:'totalAssigned', width: '10%', sortable:true},
            ],
        }
    },
    methods: {   
        showAddEdit(data) {
            this.dialogAdd = true
            this.$refs.addEditSchedule.viewEventForEdit(data)
        },
        updateHandler(data) {
            if (data!=this.$store.state.userId) {
                this.getSchedules(false)
            }
            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        },  
        viewCompanySettings() {
            this.$router.push('/company/settings')
        }, 
        addSchedule() {
            this.$refs.addEditSchedule.viewEventForAdd()
            this.dialogAdd = true
        }, 
        async getSchedules(show_loading) {        
            this.dialogAdd = false
            try{
                this.loading = show_loading
                const response = await workShiftsApi.get()
                if (response && response.status == 200) {
                    this.schedules = response.data.items.map(item => ({
                        ...item,
                        clockStartHr: this.$moment(item.clockStart).format('HH:mm'),
                        clockEndHr: this.$moment(item.clockEnd).format('HH:mm')
                    }));
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },     
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Workshifts'
        })
        
        this.getSchedules(true)
    },    
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        companyIdStr() {
            return this.$store.state.companyId
        },
        hasEditRights() {
            return commonfn.hasEditRights(this.$router.currentRoute.path)
        },
        schedules_filtered() {
            var temp = this.schedules

            //search handler
            if (this.search) {
                temp = temp.filter(item => {
                    return item.name.toLowerCase().includes(this.search.toLowerCase()) ||
                            this.$moment(item.clockStart).format('h:mm a').toLowerCase().includes(this.search.toLowerCase()) ||
                            this.$moment(item.clockEnd).format('h:mm a').toLowerCase().includes(this.search.toLowerCase())
                })
            }
            return temp //.reverse()
        },
        pageQueryId() {
            return `${this.companyIdStr}_company_workshifts`
        },
        commentsData() {
            if (!this.loading) {
                return {
                    pageQueryId: this.pageQueryId,
                    pageItemCreatedBy: null,
                    pageLink: this.$router.currentRoute.path,
                    pageKey: pageKeys.workshifts,
                    notificationTypeId: notificationTypes.workshifts
                }
            }
        },
        isMobile() {
            return window.innerWidth < 600
        },
    }
}
</script>
<style scoped>
.workshift-row {
    cursor:pointer;
}
</style>